export default {
  indicatedProfessionals: [],
  indicatedProfessional: {},
};
